module.exports = __webpack_public_path__ + "media/entities/2012-98fd69dd.png";